import { Logger } from "../core/Logger";


export class GtmLoader {
    private static wasLoaded: boolean = false;

    static load(gtmId: string): void {
        if (GtmLoader.wasLoaded) {
            return; // GTM script already loaded
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        
        // Insert at the top of head for optimal loading
        if (document.head.firstChild) {
            document.head.insertBefore(script, document.head.firstChild);
        } else {
            document.head.appendChild(script);
        }

        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        
        document.body.insertBefore(noscript, document.body.firstChild);

        GtmLoader.wasLoaded = true;
        Logger.debug(`GTM with ID ${gtmId} loaded.`);
    }
}